import { Component, Prop, h } from '@stencil/core';
import { CSOrVendorComments } from '@ugc-components/ugc-pdp-review/interface';
import state from '@ugc-store';
import { FontType } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-review-comments',
  shadow: false,
})
export class UgcReviewComments {
  @Prop() fontType: FontType = FontType.large;
  @Prop() type: CSOrVendorComments;
  @Prop() date: string = '';
  @Prop() content: string = '';

  render() {
    const {
      reviewStaticLanguage: {
        IDS_UGC_REVIEWS_BADGE_TEXT_BRAND = '',
        IDS_UGC_REVIEWS_BADGE_TEXT_CS = '',
        IDS_MANUFACTURER_RESPONSE_DISCLAIMER = '',
        IDS_MSG_SHOW_MORE = '',
        IDS_MSG_SHOW_LESS = '',
      } = {},
    } = state;
    const isLargeType = this.fontType === FontType.large;
    return (
      <div class="p-16 bg-gray-200 rounded-8">
        <div class="flex-row-between-center mb-16">
          <span
            class={`${
              this.type === CSOrVendorComments.Brand ? 'bg-orange-standard' : 'bg-green-standard'
            } fs-12 color-white px-8 py-2 rounded-16`}
          >
            {this.type === CSOrVendorComments.Brand ? IDS_UGC_REVIEWS_BADGE_TEXT_BRAND : IDS_UGC_REVIEWS_BADGE_TEXT_CS}
          </span>
          <p class={`${isLargeType ? 'fs-14' : 'fs-12'} c-666`}>{this.date}</p>
        </div>

        <ugc-ellipsis-text
          line={isLargeType ? 3 : 6}
          text={this.content}
          readMore={IDS_MSG_SHOW_MORE}
          readLess={IDS_MSG_SHOW_LESS}
          contentStyle={{ fontSize: isLargeType ? '16px' : '14px' }}
          buttonStyle={{ fontSize: isLargeType ? '14' : '12px' }}
          iconSize={isLargeType ? '24' : '15'}
        />

        {this.type === CSOrVendorComments.Brand && (
          <span class="fs-12 c-666">{IDS_MANUFACTURER_RESPONSE_DISCLAIMER}</span>
        )}
      </div>
    );
  }
}
